export default __webpack_public_path__ + "static/media/Flensborg Fjord.43be04dc.xlsx";